import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PaymentPage from './pages/PaymentPage';
import Navigation from './components/Navigation';
import EnergyExchange from './components/EnergyExchange';
import TokenSwap from './components/TokenSwap';
import TrxUsdtSwap from './components/TrxUsdtSwap';
import LanguageSwitcher from './components/LanguageSwitcher';
import './App.css';

// 主页将重定向到代币兑换页面
function HomePage() {
    return <Navigate to="/swap" replace />;
}

function App() {
    const { t, i18n } = useTranslation();
    const [isMobileDevice, setIsMobileDevice] = useState(false);

    useEffect(() => {
        // 检测是否为移动设备
        const checkIfMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        };
        setIsMobileDevice(checkIfMobile());
    }, []);

    // 当语言变化时更新文档标题
    useEffect(() => {
        document.title = t('siteTitle');
    }, [t, i18n.language]);

    return (
        <div style={{ 
            padding: '0', 
            margin: '0',
            backgroundColor: '#f5f5f5',
            minHeight: '100vh'
        }}>
            {/* 固定在左侧的语言切换器，作为独立元素放置 */}
            <div className="global-language-switcher">
                <LanguageSwitcher />
            </div>
            
            <Suspense fallback={<div>{t('loading')}</div>}>
                <BrowserRouter>
                    <Navigation />
                    <div style={{ 
                        paddingTop: isMobileDevice ? '130px' : '90px',
                        paddingBottom: isMobileDevice ? '70px' : '20px'
                    }}>
                        <Routes>
                            {/* 主页重定向到代币兑换页面 */}
                            <Route path="/" element={<HomePage />} />
                            
                            {/* 主要功能路由 - 按导航栏顺序排列 */}
                            <Route path="/swap" element={<TokenSwap />} />
                            <Route path="/trx-usdt" element={<TrxUsdtSwap />} />
                            <Route path="/energy" element={<EnergyExchange />} />
                            <Route path="/payment" element={<PaymentPage />} />
                            
                            {/* 兼容旧路由，重定向到福利专区 */}
                            <Route path="/pay/:sessionId" element={<Navigate to="/payment" replace />} />
                        </Routes>
                    </div>
                </BrowserRouter>
            </Suspense>
        </div>
    );
}

export default App;
